var map = {
	"./icon-add-bg-image.svg": 51626,
	"./icon-arrow-down.svg": 47845,
	"./icon-attach.svg": 20686,
	"./icon-blind.svg": 92214,
	"./icon-board.svg": 84751,
	"./icon-cam-disabled.svg": 60131,
	"./icon-cam.svg": 61050,
	"./icon-change-room.svg": 16307,
	"./icon-chat.svg": 63459,
	"./icon-checkmark-thick.svg": 81936,
	"./icon-checkmark.svg": 23116,
	"./icon-chrome.svg": 20675,
	"./icon-circle.svg": 49197,
	"./icon-clean-all.svg": 92226,
	"./icon-close.svg": 22023,
	"./icon-closed-eye.svg": 31537,
	"./icon-collapse-arrow.svg": 35128,
	"./icon-color.svg": 31874,
	"./icon-compress.svg": 13873,
	"./icon-connected.svg": 71286,
	"./icon-connectivity-degraded.svg": 65219,
	"./icon-copy.svg": 92866,
	"./icon-correct-circle.svg": 45310,
	"./icon-correct.svg": 76001,
	"./icon-crying-face.svg": 7045,
	"./icon-deaf.svg": 71033,
	"./icon-disconnected.svg": 19140,
	"./icon-doc.svg": 86881,
	"./icon-done.svg": 42497,
	"./icon-download-old.svg": 4613,
	"./icon-download.svg": 33793,
	"./icon-effect.svg": 20302,
	"./icon-en.svg": 35880,
	"./icon-eraser.svg": 51481,
	"./icon-error-sign.svg": 22665,
	"./icon-expand.svg": 25381,
	"./icon-eye.svg": 79400,
	"./icon-fail.svg": 54881,
	"./icon-fullscreen.svg": 9610,
	"./icon-game.svg": 53975,
	"./icon-gesture-swipe-up.svg": 791,
	"./icon-headset.svg": 35353,
	"./icon-hearing.svg": 88295,
	"./icon-help.svg": 95332,
	"./icon-historical.svg": 98785,
	"./icon-home.svg": 21564,
	"./icon-image-bg.svg": 41868,
	"./icon-info.svg": 50737,
	"./icon-internet.svg": 67710,
	"./icon-laptop-alert.svg": 46368,
	"./icon-leave.svg": 50046,
	"./icon-left.svg": 74362,
	"./icon-line-arrow-down.svg": 87616,
	"./icon-line-arrow-up.svg": 99955,
	"./icon-mail.svg": 91504,
	"./icon-mic-disabled.svg": 89479,
	"./icon-mic.svg": 96782,
	"./icon-network-quality.svg": 72673,
	"./icon-pen.svg": 2054,
	"./icon-pin.svg": 41914,
	"./icon-plus.svg": 3081,
	"./icon-pointer-filled.svg": 6969,
	"./icon-pointer.svg": 97284,
	"./icon-pop-out.svg": 6605,
	"./icon-preview.svg": 83195,
	"./icon-print.svg": 4138,
	"./icon-prohibited.svg": 19415,
	"./icon-record.svg": 55514,
	"./icon-reload.svg": 57866,
	"./icon-remove-bg-image.svg": 23135,
	"./icon-remove-image-bg.svg": 36515,
	"./icon-replace.svg": 76683,
	"./icon-required.svg": 25550,
	"./icon-right.svg": 55217,
	"./icon-sad-cloud.svg": 11615,
	"./icon-safari.svg": 64029,
	"./icon-screen.svg": 35993,
	"./icon-send-message.svg": 46241,
	"./icon-setting.svg": 94423,
	"./icon-share.svg": 83178,
	"./icon-shrink.svg": 60166,
	"./icon-siren.svg": 77832,
	"./icon-speaker-disabled.svg": 87457,
	"./icon-speaker.svg": 36108,
	"./icon-square.svg": 38048,
	"./icon-sticker.svg": 22134,
	"./icon-stopwatch.svg": 88386,
	"./icon-success.svg": 6054,
	"./icon-swap.svg": 37424,
	"./icon-system-report.svg": 45085,
	"./icon-tail-arrow-down.svg": 29032,
	"./icon-text-box.svg": 69080,
	"./icon-th.svg": 87425,
	"./icon-three-dots-animate.svg": 27986,
	"./icon-three-dots.svg": 15300,
	"./icon-to-main-room.svg": 64368,
	"./icon-uk.svg": 63621,
	"./icon-unpin.svg": 44645,
	"./icon-unpop.svg": 77421,
	"./icon-up-right.svg": 13927,
	"./icon-video-background.svg": 77207,
	"./icon-video-quality.svg": 33282,
	"./icon-vn.svg": 853,
	"./icon-warning-sign.svg": 65807,
	"./icon-warning.svg": 6827,
	"./icon-zoom-in.svg": 55220,
	"./icon-zoom-out.svg": 14459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96379;